<template>
  <div style="display: flex; flex-flow: row wrap; align-content: flex-start">
    <div
      class="card-body"
      v-for="(card, index) in cards"
      :key="index"
      @click="toDetail(card)"
    >
      <div class="edittool" v-if="editStatus">
        <div class="radio-position" @click.stop="selectRadio(card)">
          <img
            v-if="!card.showSelect"
            style="width: 20px; height: 20px"
            src="../assets/select.png"
          />
          <img
            v-if="card.showSelect"
            style="width: 20px; height: 20px"
            src="../assets/select-on.png"
          />
        </div>
        <div class="edit-status">
          <div
            @click.stop="edidProjectDetails(card)"
            class="edit-button edit-other"
          >
            编辑
          </div>
          <div @click.stop="deleteProject(card)" class="edit-button">删除</div>
        </div>
      </div>

      <div class="card-head-img">
        <img
          :src="
            card.projectImage == '' || 'null'
              ? require('@/assets/search/feature_logo.png')
              : card.projectImage
          "
        />
      </div>
      <div class="card-content">
        <p class="card-title">
          <span
            >{{ card.projectTitle }}&nbsp;&nbsp;({{ card.userName }}/{{
              card.projectName
            }})</span
          >
        </p>
        <p class="card-desc">{{ card.projectDescription?card.projectDescription:'暂无描述' }}</p>
        <p class="card-tag">项目标签</p>
        <div class="card-tag-arr">
          <span v-for="(name, index) in card.tagNames" :key="index">{{
            name
          }}</span>
        </div>
        <a-divider class="card-divider" />
        <div class="card-bottom">
          <div class="card-bottom-left">
            <span>
              &nbsp;&nbsp;创建者&nbsp;&nbsp;{{
                card.realName
              }}&nbsp;&nbsp;&nbsp;.</span
            >
            <span
              @click.stop="praiseAdd(card)"
              class="praiseText"
              :class="{ Active: card.likeStatus == 1 }"
            >
              &nbsp;&nbsp; {{ card.projectLikeNum }} &nbsp; 赞</span
            >
            <!-- :class="{{Active:i===index}}" -->
          </div>
          <div class="card-bottom-right">
            <img
              :src="card.avatar || require('@/assets/avatar.png')"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import projectLike from "@/request/api-manager/projectLike.js";
import { USER_ID } from "@/store/mutation-types";
import project from "@/request/api-manager/project.js";
import Vue from "vue";
export default {
  name: "HmSearchCard",
  data() {
    return {
      // card:[],
    };
  },
  props: {
    showSelect: {
      type: Boolean,
    },
    editStatus: {
      type: Boolean,
    },
    cards: {
      type: Array,
    },
    list_params: {
      type: Object,
    },
  },
  watch: {
    cards(val) {
      let self = this;
      self.dealCardData(val);
    },
  },
  methods: {
    dealCardData(cards) {
      cards.forEach((card) => {
        card.projectLikeNum =
          card.projectLikeNum == "" || card.projectLikeNum == null
            ? 0
            : card.projectLikeNum;
        card.tagNames =
          card.tagNames == "" || card.tagNames == null
            ? ["暂无标签"]
            : _.compact(_.split(card.tagNames, ","));
      });
      
    },
    // 点赞+1
    praiseAdd(card) {
      let self = this;
      if ( card.projectLikeId == '') {
        //如果不存在项目点赞表id
        self.addProjectLike(card); //调用增加项目点赞表接口
      }else if (card.projectLikeId!=''&&card.likeStatus==1) { //取消点赞
        self.editProjectLike(card,0)
      }else if (card.projectLikeId!=''&&card.likeStatus==0){
        self.editProjectLike(card,1)
      }
    },
    editProjectLike(card,num){
      let self = this;
      let params = {
        id: card.projectLikeId,
        status: num,
      };
      let msg = num === 1 ? '点赞' : '取消点赞'
      let numChange = num === 1 ? 1 : -1
      projectLike.edit(params).then((res) => {
        if (res.success) {
           self.$emit("viewProjectTagList", self.list_params);
          self.$message.success(msg + "成功");
        } else {
          self.$message.error(msg + "失败");
        }
      });
    },
    //往项目点赞表中新增数据
    addProjectLike(card) {
      let self = this;
      let params = {
        projectId: card.id,
        sysUserId: Vue.ls.get(USER_ID),
        status: 1,
      };
      projectLike.add(params).then((res) => {
        if (res.success) {
           self.$emit("viewProjectTagList", self.list_params);
          self.$message.success("点赞成功");
        } else {
          self.$message.error("点赞失败");
        }
      });
    },
    selectRadio(card) {
      this.$emit("selectRadio", card);
    },
    edidProjectDetails(card) {
      console.log("触发事件", card);
      this.$emit("edidProjectDetails", card);
    },
    deleteProject(card) {
      this.$emit("deleteProject", card.id);
    },
    toDetail(card) {
      this.$emit("toDetail", card.id);
    },
  },
};
</script>

<style lang="less" scoped>
.card-body {
  position: relative;
  background-color: #fff;
  width: 323px;
  height: 400px;
  margin: 12px;
  cursor: pointer;
  display: inline-block;
  .card-head-img {
    height: 160px;
    img {
      height: 100%;
    }
  }
  .card-content {
    width: 283px;
    margin: 15px 20px 0 20px;
    .card-title {
      font-family: PingFangSC-Medium;
      font-size: 18px;
      color: #333333;
      text-align: left;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      -webkit-line-clamp: 1;
    }
    .card-desc {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #666666;
      text-align: justify;
      overflow: hidden;
      /*white-space: nowrap;*/
      /*text-overflow: ellipsis;*/
      -webkit-line-clamp: 2;
      display: -webkit-box;
      -webkit-box-orient: vertical;
    }
    .card-tag {
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #999999;
      text-align: left;
    }
    .card-tag-arr {
      text-align: left;
      span {
        background: #f5f5f5;
        border-radius: 4px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #666666;
        padding: 5px 10px;
        margin: 0 5px;
      }
      span:first-child {
        margin-left: 0;
      }
    }
    .card-divider {
      height: 1px;
    }

    .card-bottom {
      display: flex;
      justify-content: space-between;
      margin-top: -15px;
      .card-bottom-left span {
        font-family: HelveticaNeue;
        font-size: 12px;
        color: #999999;
      }
      .card-bottom-right img {
        width: 26.6px;
        height: 26.6px;
        margin-left: -13px;
      }
    }
  }
}
.praiseText {
  cursor: pointer;
}
.Active {
  color: red !important;
}

.edittool {
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.3);
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1000;
  /* display: none; */
}

.radio-position {
  position: absolute;
  top: 15px;
  right: 15px;
}

.edit-status {
  display: flex;
  width: 100%;
  position: absolute;
  line-height: 50px;
  bottom: 0;
  background-color: #ffffff;
}

.edit-button {
  width: 50%;
  text-align: center;
  box-sizing: border-box;
}

.edit-other {
  color: #fa493c;
  border-right: 1px #e8e8e8 solid;
}
</style>